export type SignupEventName =
  | 'google_signup'
  | 'email_signup'
  | 'spotify_curator_signup'

const STORAGE_KEYS: Record<SignupEventName, string> = {
  google_signup: 'sentGoogleSignupUsers',
  email_signup: 'sentEmailSignupUsers',
  spotify_curator_signup: 'sentSpotifyCuratorSignupUsers',
}
const MAX_STORED_IDS = 20

const readSentIds = (eventName: SignupEventName): string[] => {
  const raw = localStorage.getItem(STORAGE_KEYS[eventName])
  if (!raw) {
    return []
  }
  try {
    const parsed = JSON.parse(raw) as unknown
    return Array.isArray(parsed) ? parsed.map(String) : []
  } catch {
    return []
  }
}

export const hasSentSignup = (
  eventName: SignupEventName,
  userId: string,
): boolean => readSentIds(eventName).includes(userId)

export const markSignupSent = (
  eventName: SignupEventName,
  userId: string,
): void => {
  const ids = readSentIds(eventName).filter((id) => id !== userId)
  ids.push(userId)
  localStorage.setItem(
    STORAGE_KEYS[eventName],
    JSON.stringify(ids.slice(-MAX_STORED_IDS)),
  )
}
